import { createStore } from 'zustand'
import { GoalHabitsInitialState, GoalHabitsStore } from './types'
import { transformMonthData, transformWeekData } from '../utils'

export const createGoalHabitsStore = ({
  ...initialState
}: GoalHabitsInitialState) => {
  return createStore<GoalHabitsStore>()((set, get) => ({
    ...initialState,
    periodType: 'week',
    weekData: [],
    weekMaxValue: 0,
    weekTotalRead: 0,
    weekYAxisInterval: 1,
    monthData: [],
    monthMaxValue: 0,
    monthAvgRead: 0,
    isZeroState: false,
    setPeriod: (period) => set({ periodType: period }),
    setWeekData: ({ data, year, yearStatus, goalType }) => {
      const week = transformWeekData({
        results: data,
        year,
        yearStatus,
        goalType,
      })

      set({
        weekData: week.data,
        weekMaxValue: week.maxValue,
        weekTotalRead: week.totalRead,
        weekYAxisInterval: week.yAxisInterval,
        isZeroState: week.isZeroState,
      })
    },
    setMonthData: ({ data, yearStatus, goalType }) => {
      const month = transformMonthData({ results: data, yearStatus, goalType })
      set({
        monthData: month.data,
        monthMaxValue: month.maxValue,
        monthAvgRead: month.averageRead,
        isZeroState: month.isZeroState,
      })
    },
  }))
}
